var map = {
	"./2smartphones.svg": "f330",
	"./Logo_FondoAmarillo_LetrasNegras.svg": "e3ba",
	"./Logo_FondoBlanco_LetrasNegras.svg": "149d",
	"./Logo_FondoNegro_LetrasBlancas.svg": "51a3",
	"./Logo_principal.svg": "7367",
	"./calendario.svg": "c86b",
	"./camara.svg": "999f",
	"./consolas.svg": "aabd",
	"./daño.svg": "2858",
	"./electrodomesticos.svg": "fc51",
	"./interrogacion.svg": "e030",
	"./laptop.svg": "f2f6",
	"./laptop_daños.svg": "26e9",
	"./laptop_robo.svg": "2825",
	"./laptop_robo2.svg": "6ad2",
	"./laptop_roturas.svg": "7a44",
	"./logo-redondo.svg": "17f2",
	"./multi_daños.svg": "a4ed",
	"./multi_robo.svg": "17cd",
	"./multi_robo2.svg": "288b",
	"./multi_roturas.svg": "d10d",
	"./multimedia.svg": "f5ce",
	"./qr.svg": "da0e",
	"./robo.svg": "e3f8",
	"./robo2.svg": "3ac5",
	"./rotura.svg": "6ed5",
	"./smartTV.svg": "0bc3",
	"./smartphone.svg": "8368",
	"./smartwatch.svg": "3b32",
	"./tablet.svg": "c196",
	"./voltage.svg": "1475"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c25";